import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'
import {AddressType, Errors} from "./const";

const Log = new Logger("StoreLocator");

class StoreLocator {


  defaultOptions(options) {
    const clustersOpt = {
      Google:{
        ClusterMaxZoom: 7,
        ClusterMinSize: 3,
        ClusterGridSize: 60,
      },
      Baidu:{
        ClusterMinSize: 3,
        ClusterGridSize: 60,
      }
    };
    if(options && options.ClustersOpt) {
      options.ClustersOpt=Object.assign({},clustersOpt,options.ClustersOpt)
    }
    const opt = Object.assign(
  {

          Engines: {},

          /* Key of `storeCode` into JSON */
          "markerkey": "storeCode",

          /* DOM element which will be used for specifing the map engines and search engines */
          selectors: {
            maps: "", // "div.map[data-map-engine]",
            searches: "" // "div.search[data-search-engine]"
          },
          /* Allowed types of address returned by google autocomplete */
          AllowedAddressType: [], // ["locality", "geocode", "country", "political", "route", "street_address"],
          /* (debug) Show or hide a rectangle representing the bounding box into map */
          ShowMapRectangle: false,
          /* The percentage used for switching between Naver and Google */
          CoreanPercentageSwitch: 25,

          searchMinLengh: 3,

          ClustersOpt: clustersOpt,

          Maps: {
            Google: {
              mapTypeControl: false,
              overviewMapControl: false,
              panControl: false,
              scaleControl: false,
              streetViewControl: false,
              scrollwheel: false,
              minZoom: 1,
              maxZoom: 18,
              zoom: 8,
              zoomControl: false,
              gestureHandling: "greedy"
            },
            Baidu:{
              //http://lbsyun.baidu.com/cms/jsapi/reference/jsapi_reference.html#a0b1 -> MapOptions
              minZoom: 3,
              maxZoom: 19,
              enableScrollWheelZoom:false,
              //mapType -> Map type, default is BMAP_NORMAL_MAP
              //enableHighResolution -> Whether to enable the use of high-resolution maps. On iPhone4 and subsequent devices, you can get a higher resolution basemap by turning on this option. The v1.2 and v1.3 versions are not enabled by default, and v1.4 is enabled by default
              //enableAutoResize -> Whether to automatically adapt to map container changes, enabled by default
              //enableMapClick -> Whether to enable the clickable basemap function, enabled by default
              zoom: 8, // custom
            }
          }

        },
        options
    );

    opt.ClustersOpt.imageRootPath = opt.ClustersOpt.imageRootPath || '';
    opt.ClustersOpt.Google.ClusterImageExt = "png";

    opt.ClustersOpt.Baidu.ClusterImagePath = opt.ClustersOpt.imageRootPath+"/images/markers/cluster/cluster";
    opt.ClustersOpt.Baidu.ClusterImageExt = "svg";


    return opt;
  }

  get Version() {
    return '3.0.0';
  }


  /**
   * Constructor method
   *
   * @param element: HTML DOM element used to wrap each Map engine and Search engine
   * @param options: literal object containing configuration properties
   */
  constructor(options){

    this.options = $.extend(true, {}, this.defaultOptions(options));

    this._zoom = 0;
    this.__searchEngines__ = {};
    this.__map_engines__ = {};

    this.__map__ = null;

    this.AddressType=AddressType;
    this.Errors=Errors;

  }

  /** Collection which store searchengine to */
  get SearchEngines() {
    return this.__searchEngines__;
  }

  /** Collection which store mapengine to */
  get MapsEngines() {
    return this.__map_engines__;
  }

  get Engines() {
    return this.options.Engines;
  }

  /** Current MapEngine */
  get Map() { return this.__map__; }
  set Map(m) { return this.__map__ = m; }

  /**
   * Utility method for selecting MapEngine used to navigate the map
   *
   * @param viewport: object representing the Map bounds coordinates of the entire viewport
   * @param bounds: object representing the searched bounds coordinates
   * @param zoom: the actual zoom level
   */
  selectMapEngine(viewport, bounds, zoom) {

    Log.debug("Choose map engine for viewport", viewport, bounds, "zoom:", zoom);

    let map;
    // Loop through MapsEngines to find the correct one for display the bounds
    $.each(this.MapsEngines, (i, eng) => {
      if ( eng.test(viewport, bounds, zoom) ) {
        Log.debug("Map engine found:", i);
        map = eng;
        return false;
      }
    });

    return map;
  }


  /**
   *  Utility method used for searching given string through SearchEngines
   *
   *  @param str: String to be searched
   *  @param use_bounds: boolean which restricts results to bounds coordinates of map
   */
  search(str, use_bounds) {

    return new Promise( (resolve, reject) => {

      let all_promises = [];

      $.each(this.SearchEngines, function(i, engine){

        all_promises.push( engine.search(str, use_bounds && this.Map.bounds ) );

      });

      Promise.all( all_promises ).then( (result) => {
        resolve( result );
      });

    });

  }


  currentLocation(opts) {
    //debugger;
    return new Promise( (resolve, reject) => {
      if ( navigator.geolocation ) {
        navigator.geolocation.getCurrentPosition( (pos) => {


          resolve({lat: pos.coords.latitude, lng: pos.coords.longitude, location: pos});

        }, () => {
          reject(Errors.NO_LOCATION)
        }, $.extend(true, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }, opts));
      } else {
        reject( Errors.NO_GEOLOCATION );
      }
    })
  }


  /**
   *  Navigate to the given address through MapsEngines
   *
   *  @param address: String representing the address to be navigating to
   *  @param location: literal object representing the address to be navigating to as per {google.maps.LatLng}
   */
  navigate(address, location, force_fixed_point) {
    //debugger;
    return new Promise( (resolve, reject) => {
      const searchEngine=this.getFirstSearchEngine();
      searchEngine && searchEngine.geocode(address,location,force_fixed_point,this.options,resolve,reject,this.trigger.bind(this));
    });
  }

  getFirstSearchEngine(){
    const searchEngines = this.SearchEngines;
    const keys=Object.keys(searchEngines||{})
    if(searchEngines && keys.length>0){
      return searchEngines[keys[0]];
    }
  }

  /**
   * Utility method used to navigate directly to a bound coordinates
   *
   * @param bounds: object representing the bounds coordinates used to navigated to
   */
  navigateLocation(bounds, zoom) {
    //debugger;

    return new Promise( (resolve, reject) => {
      //debugger;
      // simulate navigation using current Map engine
      Log.log("Navigating to location using", this.Map );

      let currentMap = this.Map;

      // Do not catch events
      this.unbindEventOnMap( currentMap );

      let prev_viewport = currentMap.viewport;

      // Navigate to bounds
      currentMap.navigate( bounds );

      if ( zoom ){
        this.zoom = zoom;
      }

      let change_viewport = true;
      if ( prev_viewport ) {
        change_viewport = !currentMap.Map.getBounds().equals( currentMap.getBoundsFromCoords( prev_viewport ) );
      }

      Log.debug( "Change viewport", change_viewport  );


      let execNavigation = () => {
        Log.log("Navigated using", currentMap);

        // Get the new viewport coordinates
        let viewportBounds = currentMap.bounds;
        // Get the Zoom level index
        let _zoom = this.zoom;

        Log.info("Testing map engine for viewport", viewportBounds, "zoom:", _zoom );

        // Search and find a new MapEngine for handling the new viewport coordinates
        if ( this.selectAndSwitchMap( viewportBounds, bounds, _zoom ) ) {
          // a new MapEngine has been found: switch to the new one
          this.trigger("navigateTo", this.Map, bounds);
          resolve();
        } else {
          reject(Errors.NO_MAP_FOUND);
        }
      }

      /*
       * Listen to `idle` event
       * This event will be fired once MapEngine has finished navigating to bounds
       */

      if ( ! change_viewport ) {
        execNavigation();
      } else {
        let rem_idle_ev = currentMap.on(currentMap.IDLE_EVENT_NAME, () => {
          // No more listen to the `idle` event
          currentMap.off(currentMap.IDLE_EVENT_NAME);
          execNavigation();
        });
      }

    });
  }


  /**
   * Expand viewport in order to show given point
   *
   * @param point: literal object representing the Pin coordinates `{lat: 0, lng: 0}`
   */
  expandViewport(point) {
    //debugger;
    let bounds = this.Map.addPointToViewport( point );
    this.navigateLocation( bounds );
  }


  /**
   * Private method
   * Set viewport, bounds and zoom level to selected MapEngine
   *
   * @param viewport: object representing viewport coordinates
   * @param bounds: object representing the bounds coordinates used to navigated to
   * @param zoom: current zoom level index
   */
  selectAndSwitchMap( viewport, bounds, zoom ) {
    //debugger;

    // standardize coordinates
    viewport = JSON.parse( JSON.stringify(viewport) );

    // in case of `moving on map` we haven't bounds, but only viewport
    bounds = bounds ? JSON.parse( JSON.stringify( bounds ) ) : null;

    // select Map engine
    let map = this.selectMapEngine( viewport, bounds || {}, zoom );

    if ( map  && ( map !== this.Map ) ){
      // Map engine is changed

      // Deactivate current Map engine
      this.Map.deactivate();

      // Navigate to the map using new Map engine
      map.navigate( bounds || viewport, true );

      // set center
      map.center = this.Map.getCenter();

      // set current zoom level
      map.zoom = this.zoom;

      this.trigger("switchmap", this.Map, map);

      // new Map engine is being used by default
      this.Map = map;

      // Activate Map engine
      this.Map.activate();



    } else if ( ! map ) {
      Log.error("No map engine found!");
      return false;
    }

    // Just to be sure: remove all events listeners
    this.unbindEventOnMap( map );

    // Rebind events to map
    this.bindEventOnMap( map );

    return true;
  }


  /**
   * Unbinds all events listeners to given MapEngine
   *
   * @param map: MapEngine to unbind events to
   */
  unbindEventOnMap(map) {
    //debugger;

    this.rem_bounds_changed_ev && map.off(this.rem_bounds_changed_ev);

    this.rem_idle_ev && map.off(this.rem_idle_ev);

    this.rem_selectpoint_ev && map.off(this.rem_selectpoint_ev);

    this.rem_zoom_ev && map.off( this.rem_zoom_ev );

    this.rem_dragend_ev && map.off( this.rem_dragend_ev );

  }


  /**
   * Binds all events listeners to given MapEngine
   *
   * @param map: MapEngine to bind events to
   */
  bindEventOnMap(map) {
    //debugger;
    let changed = false;

    this.rem_bounds_changed_ev = map.on(map.BOUNDS_CHANGED_EVENT_NAME, (e) => {
      // Get/set the zoom level
      let zoom = this.zoom;
      changed = true;
    })

    let timer;
    this.rem_idle_ev = map.on(map.IDLE_EVENT_NAME, () => {
      clearTimeout(timer);
      timer = setTimeout( () => {
        changed = false;
        this.selectAndSwitchMap( map.bounds, undefined, this.zoom );
        this.trigger("moveinmap", this.Map );
      }, 10);
    });

    this.rem_selectpoint_ev = map.on(map.SELECTPOINT_EVENT_NAME, (e, markerpoint) => {
      this.trigger("selectpoint", map, markerpoint);
    });

    var c_zoom = this.zoom;
    this.rem_zoom_ev = map.on(map.ZOOM_CHANGED_EVENT_NAME, () => {
      this.trigger("mapzoom", c_zoom, map.zoom );
      c_zoom = this.zoom;
    });

    this.rem_dragend_ev = map.on(map.DRAGEND_EVENT_NAME, () => {
      this.trigger("mappan");
    });

  }


  /**
   * Return a specified Marker from current map engine
   *
   * @param code: String representing the store-code for getting the Marker
   */
  getMarker(code) {
    return this.Map.getMarker( code );
  }


  /**
   * Show markers on Map
   *
   * @param points: a GeoJSON object representing all marker
   * @param use_cluster: optional boolean arguments; enables/disables Clusterer
   */
  showPoint(points, use_cluster) {
    //debugger;
    return new Promise( (resolve, reject) => {
      let mrks = this.Map.showMarker( points, use_cluster );
      resolve(mrks);
    });
  }


  /**
   * Set/Get method for zoom level index
   *
   * @param delta: numeric value
   */
  get zoom() {
    // return the current zoom level index
    return this._zoom = this.Map.zoom;
  }

  set zoom(delta) {
    // set new zoom value
    this.Map.zoom = this._zoom + delta;

    // get new zoom level index
    this._zoom = this.Map.zoom;
  };


  /**
   * Used to store all engines
   */
  addMapEngine(name, engine){
    this.MapsEngines[ name ] = engine;
    if ( ! this.Map ) {
      // No 'main' map engine found: use the first one in the list
      Log.warn("No default Map engine found, select the first one");
      this.Map = engine;
      this.Map.activate();
    }
  }

  removeMapEngine(name) {
    let engine = this.MapsEngines[ name ];
    if ( this.Map === engine ) {
      this.Map = null;
    }
    delete this.MapsEngines[ name ];
  }


  addSearchEngine(name, engine) {
    this.SearchEngines[ name ] = engine;
  }

  removeSearchEngine(name) {
    delete this.SearchEngines[ name ];
  }


  /**
   * Add a event listener function
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  on(ev, fn){
    $(this).on(ev, fn);
    return this;
  }

  /**
   * Remove a event listener function
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  off(ev, fn){
    $(this).off(ev, fn);
    return this;
  }

  /**
   * Fires a event
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  trigger(ev, ...args) {
    let $t = $(this)
    $t.trigger.call($t, ev, args );
    return this;
  };

}

export default StoreLocator
